import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 40px 24% auto 18% 40px;
  height: 100vh;
  background-color: #eee;
`
